import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ITrackingAction, ITrackingObject } from 'i2g-ng-tracking';

@Component({
  selector: 'i2g-job-detail-list-item',
  templateUrl: 'job-detail-list-item.component.html',
  styleUrls: ['job-detail-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobDetailListItemComponent implements OnInit {
  @Input() label: string;
  @Input() value: string;
  @Input() link: string;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingObject: ITrackingObject;

  constructor() {}

  ngOnInit() {}
}
